import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./admin.css";
import "./usermember.css";
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { apiService } from '../../services/apiService';
import Select from 'react-select';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { getCountryCallingCode, isValidPhoneNumber } from 'libphonenumber-js';
import { EMAIL_FORMAT_REGEX, EMAIL_FIELDS } from '../../components/common/validationPatterns';
function UserMemberAdd() {
    const allowedCountries = ['US', 'IN', 'CA', 'DE', 'AU', 'GB', 'PK'];
    const maxPhoneLengths = { 
        US: 10,  // United States
        IN: 10,  // India
        CA: 10,  // Canada
        DE: 11,  // Germany
        AU: 9,   // Australia
        GB: 10,  // United Kingdom
        PK: 10   // Pakistan
    };
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        address: '',
        email: '',
        phone_number: '',
        business_number: '',
        dob: null,
        password: '',
        password_confirmation: '',
        profile: null,
        start_date: null,
        industry_start_date: null,
        manager_id: null,
        job_title: null,
        is_review: 0,
        partnership_status: 0,

        primary_department:"",
        industry_sector:"",
        linkedin_url:"",
        is_whatsapp:"",
        is_business:"",
        whatsapp_number:"",
        business_whatsapp_number:"",
    });
    const [errors, setErrors] = useState({});
    const [btnloading, setBtnLoading] = useState(false);
    const [errorsmessage, setErrorMessage] = useState('');
    // const [rolesOptions, setRolesOptions] = useState([]);
    const [preview, setPreview] = useState(null);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [passwordVisible2, setPasswordVisible2] = useState(false);
    const [managerList, setManagers] = useState([]);
    const [selectedManager, setSelectedManager] = useState(null);
    // Toggle password visibility
    const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
    const togglePasswordVisibility2 = () => setPasswordVisible2(!passwordVisible2);
    

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.postRequest(`manager_list`);
            if (response.success) {
                setManagers(response.data);
            }
        };
        fetchData();
    }, []);
    const handleManagerChange = (selectedOption) => {
        setSelectedManager(selectedOption);
        handleInputChange({
            target: {
                name: 'manager_id',
                value: selectedOption ? selectedOption.value : ''
            }
        });
    };
    // Handle image selection and clear profile error if changed
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, profile: file });
            const reader = new FileReader();
            reader.onloadend = () => setPreview(reader.result);
            reader.readAsDataURL(file);

            // Clear profile error
            if (errors.profile) {
                setErrors({ ...errors, profile: '' });
            }
        }
    };

    // Clear specific errors when inputs are modified
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = EMAIL_FIELDS.includes(name) ? value.replace(/^\s+|\s+$/g, '') : value;
        setFormData({ ...formData, [name]: sanitizedValue });

        // Clear the error for the changed field
        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };

    const handleEmailKeyDown = (e) => {
        if (e.key === ' ') {
            e.preventDefault();
        }
    };
    const handleDateChange = (date) => {
        setFormData({ ...formData, dob: date });
        
        if (errors.dob) {
            setErrors({ ...errors, dob: '' });
        }
    };
    const handleDateChange2 = (date) => {
        setFormData({ ...formData, start_date: date });
        
        if (errors.start_date) {
            setErrors({ ...errors, start_date: '' });
        }
    };
    const handleDateChange3 = (date) => {
        setFormData({ ...formData, industry_start_date: date });
        
        if (errors.industry_start_date) {
            setErrors({ ...errors, industry_start_date: '' });
        }
    };

    const handlePhoneChange = (value, fieldName) => {
        if (!value) {
            handleInputChange({ target: { name: fieldName, value: '' } });
            return;
        }
        const country = allowedCountries.find(
            (c) => value.startsWith(`+${getCountryCallingCode(c)}`)
        ) || 'US';
        const countryCode = `+${getCountryCallingCode(country)}`;
        const maxLength = maxPhoneLengths[country];
        // Strip the country code and check the actual phone number length
        const nationalDigits = value.replace(countryCode, '').replace(/\D/g, '');
        const truncatedValue = nationalDigits.length > maxLength
            ? countryCode + nationalDigits.slice(0, maxLength)
            : value;
        handleInputChange({ target: { name: fieldName, value: truncatedValue } });
    };

    const isValidPhoneLength = (value) => {
        if (!value) return false;
        const country = allowedCountries.find(
            (c) => value.startsWith(`+${getCountryCallingCode(c)}`)
        ) || 'US';
        const nationalDigits = value.replace(`+${getCountryCallingCode(country)}`, '').replace(/\D/g, '');
        return nationalDigits.length === maxPhoneLengths[country];
    };
    const handleKeyDown = (event, fieldName) => {
        const { key } = event;
        const currentValue = formData[fieldName] || ''; // Use dynamic field name
        const country = allowedCountries.find(
            (c) => currentValue.startsWith(`+${getCountryCallingCode(c)}`)
        ) || 'US';

        const maxLength = maxPhoneLengths[country];

        // Remove country code and check the actual phone number length
        const phoneWithoutCode = currentValue.replace(`+${getCountryCallingCode(country)}`, '').replace(/\D/g, '');

        if (phoneWithoutCode.length >= maxLength && /\d/.test(key)) {
            event.preventDefault(); // Stop further input
        }
    };

    // Basic validation logic
    const validate = () => {
        const newErrors = {};
        if (!formData.first_name) newErrors.first_name = 'First name is required';
        if (!formData.last_name) newErrors.last_name = 'Last name is required';
        if (!formData.address) newErrors.address = 'Address is required';
        if (!formData.email) newErrors.email = 'Email is required';
        else if (!EMAIL_FORMAT_REGEX.test(formData.email)) newErrors.email = 'Please enter a valid email address.';
        if (!formData.phone_number) {
            newErrors.phone_number = 'Personal phone number is required';
        } else if (!isValidPhoneNumber(formData.phone_number) || !isValidPhoneLength(formData.phone_number)) {
            newErrors.phone_number = 'Enter a valid phone number.';
        }
        if (!formData.business_number) {
            newErrors.business_number = 'Business phone number is required';
        } else if (!isValidPhoneNumber(formData.business_number) || !isValidPhoneLength(formData.business_number)) {
            newErrors.business_number = 'Enter a valid phone number.';
        }
        if (!formData.dob) newErrors.dob = 'Date of birth is required';

        if (!formData.manager_id) newErrors.manager_id = 'Manager is required';
        if (!formData.start_date) newErrors.start_date = 'Start date is required';
        if (!formData.industry_start_date) newErrors.industry_start_date = 'Industry start date is required';
        if (!formData.job_title) newErrors.job_title = 'Job title is required';
        if (!formData.partnership_status) newErrors.partnership_status = 'Partnership status is required';
        
        if (!formData.primary_department) newErrors.primary_department = 'Primary department is required';
        if (!formData.industry_sector) newErrors.industry_sector = 'Industry sector is required';
        if (!formData.linkedin_url) newErrors.linkedin_url = 'Linkedin URL is required';
        if (formData.is_whatsapp === "") newErrors.is_whatsapp = 'Personal phone number support whatsapp is required';
        if (formData.is_business === "") newErrors.is_business = 'Business Phone number support business whatsapp is required';
        if(formData.is_whatsapp === 0){
            if (!formData.whatsapp_number) {
                newErrors.whatsapp_number = 'Personal Whatsapp number is required';
            } else if (!isValidPhoneNumber(formData.whatsapp_number) || !isValidPhoneLength(formData.whatsapp_number)) {
                newErrors.whatsapp_number = 'Enter a valid phone number.';
            }
        }
        if(formData.is_business === 0){
            if (!formData.business_whatsapp_number) {
                newErrors.business_whatsapp_number = 'Business whatsapp number is required';
            } else if (!isValidPhoneNumber(formData.business_whatsapp_number) || !isValidPhoneLength(formData.business_whatsapp_number)) {
                newErrors.business_whatsapp_number = 'Enter a valid phone number.';
            }
        }
        
        if (!formData.password) newErrors.password = 'Password is required';
        if (!formData.password_confirmation) newErrors.password_confirmation = 'Please confirm your password';
        else if (formData.password !== formData.password_confirmation) newErrors.password_confirmation = 'Passwords do not match';
        // if (formData.roles.length === 0) newErrors.roles = 'At least one Group is required';

        const password = formData.password;
        const passwordFormat = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+\\|{};:/?.<>])[\w!@#$%^&*()\-_=+\\|{};:/?.<>]{8,}$/;
        if (!passwordFormat.test(password)) {
            newErrors.password = 'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and any one special character.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        const data = new FormData();
        data.append('first_name', formData.first_name);
        data.append('last_name', formData.last_name);
        data.append('address', formData.address);
        data.append('email', formData.email);
        data.append('phone_number', formData.phone_number);
        data.append('business_number', formData.business_number);
        if (formData.dob) {
            data.append('dob', dayjs(formData.dob).format('YYYY-MM-DD'));
        }
        data.append('manager_id', formData.manager_id);
        data.append('is_review', formData.is_review);
        if (formData.start_date) {
            data.append('start_date', dayjs(formData.start_date).format('YYYY-MM-DD'));
        }
        if (formData.industry_start_date) {
            data.append('industry_start_date', dayjs(formData.industry_start_date).format('YYYY-MM-DD'));
        }
        data.append('job_title', formData.job_title);
        data.append('partnership_status', formData.partnership_status);
        data.append('password', formData.password);
        data.append('password_confirmation', formData.password_confirmation);

        data.append('primary_department', formData.primary_department);
        data.append('industry_sector', formData.industry_sector);
        data.append('linkedin_url', formData.linkedin_url);
        data.append('is_whatsapp', formData.is_whatsapp);
        data.append('is_business', formData.is_business);
        if(formData.is_whatsapp === 0){
            data.append('whatsapp_number', formData.whatsapp_number);
        }
        if(formData.is_business === 0){
            data.append('business_whatsapp_number', formData.business_whatsapp_number);
        }
        if (formData.profile) {
            data.append('profile', formData.profile);
        }

        setBtnLoading(true);
        try {
            const response = await apiService.postRequest('/admin/users', data);
            if (response && response.success === true) {
                navigate('/user/member');
                toast(response.message || "Member added successfully!");
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error adding user:', error);
        } finally {
            setBtnLoading(false);
        }
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container justifyContent="center" className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>User</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/user/member")}>User</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/user/member")}>Sub Admin</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Add Sub Admin</span>
                    </Grid>
                    <Grid size={{xs:12}} container className="editgrouphead my-4">
                        <h2>Add Sub Admin</h2>
                    </Grid>
                </Grid>
                <form className='row justify-content-center w-100' onSubmit={handleSubmit}>
                    <Grid size={{sm:11,xs:12}} container justifyContent="space-between" className="add_memberfields">
                        <Grid size={{sm:12,xs:12}} container alignItems="center" className="profile_uploadlab mb-5">
                            <div className="profile-upload-wrapper">
                                <label htmlFor="profile-upload-input" className="profile-upload-label">
                                    {preview ? (
                                        <img src={preview} alt="Profile Preview" className="profile-preview" />
                                    ) : (
                                        <div className="placeholder-icon">
                                            <img src={require('../../assets/cameraicon.svg').default} alt='Upload'/>
                                        </div>
                                    )}
                                </label>
                                <input
                                    id="profile-upload-input"
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    style={{ display: 'none' }}
                                />
                            </div>
                            <small>Upload Profile Picture</small>
                        </Grid>
                        <Grid size={{xs:12}} container>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Email Id<small className='red_starimpo'>*</small></span>
                                <input type="text"  name="email" value={formData.email} onChange={handleInputChange} onKeyDown={handleEmailKeyDown}/>
                                {errors.email && <p style={{color:"red"}}>{errors.email}</p>}
                            </Grid>
                        </Grid>
                        <Grid size={{xs:12}} container justifyContent="space-between">
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="mb-4">
                                <span>Password<small className='red_starimpo'>*</small></span>
                                <div className='d-flex input_witheye'>
                                    <input
                                        name="password"
                                        type={passwordVisible ? 'text' : 'password'}
                                        value={formData.password}
                                        onChange={handleInputChange}
                                        placeholder="Abcd123#"
                                        autoComplete="new-password"
                                        style={{ width: '100%', paddingRight: '40px' }}
                                    />
                                    <button type="button" onClick={togglePasswordVisibility}>
                                        {passwordVisible ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                    </button>
                                </div>
                                {errors.password && <p style={{color:"Red"}}>{errors.password}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="mb-4">
                                <span>Confirm Password<small className='red_starimpo'>*</small></span>
                                <div className='d-flex input_witheye'>
                                    <input
                                        name="password_confirmation"
                                        value={formData.password_confirmation}
                                        onChange={handleInputChange}
                                        type={passwordVisible2 ? 'text' : 'password'}
                                        placeholder="Abcd123#"
                                        autoComplete="new-password"
                                        style={{ width: '100%', paddingRight: '40px' }}
                                    />
                                    <button type="button" onClick={togglePasswordVisibility2}>
                                        {passwordVisible2 ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                    </button>
                                </div>
                                {errors.password_confirmation && <p style={{color:"red"}}>{errors.password_confirmation}</p>}
                            </Grid>
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                            <span>First Name<small className='red_starimpo'>*</small></span>
                            <input type="text" name="first_name" value={formData.first_name} onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}/>
                            {errors.first_name && <p style={{color:"red"}}>{errors.first_name}</p>}
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                            <span>Last Name<small className='red_starimpo'>*</small></span>
                            <input type="text" name="last_name" value={formData.last_name} onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}/>
                            {errors.last_name && <p style={{color:"red"}}>{errors.last_name}</p>}
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                            <span>Date of Birth<small className='red_starimpo'>*</small></span>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    className="date_pickermux"
                                    value={formData.dob}
                                    onChange={handleDateChange}
                                    maxDate={dayjs().subtract(18, 'year').subtract(1, 'day')}
                                    renderInput={(params) => <input {...params} />}
                                />
                            </LocalizationProvider>
                            {errors.dob && <p style={{color:"red"}}>{errors.dob}</p>}
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                            <span>Manager<small className='red_starimpo'>*</small></span>
                            <Select
                                className="basic-single select_withsearch"
                                classNamePrefix="select"
                                value={selectedManager}
                                defaultValue={null}
                                name="manager_id"
                                options={managerList && managerList.map((managerLists) => ({
                                    label: managerLists.name,
                                    value: managerLists.id,
                                }))}
                                onChange={handleManagerChange}
                            />
                            {errors.manager_id && <p style={{color:"red"}}>{errors.manager_id}</p>}
                        </Grid>
                        <Grid size={{xs:12}} container className="mb-4 gap-2">
                            <input className='checkbox_inputes' onChange={(e) => 
                                    handleInputChange({
                                    target: { name: "is_review", value: e.target.checked ? 1 : 0 }
                                    })
                                } checked={formData.is_review === 1} type='checkbox'/>
                            <span>Allow Reviews</span>
                        </Grid>
                        <Grid size={{ xs: 12 }} container flexDirection="column" className="memberfield_individual mb-4">
                            <span>Address<small className='red_starimpo'>*</small></span>
                            <input
                                type="text"
                                name="address"
                                value={formData.address}
                                onChange={handleInputChange}
                            />
                            {errors.address && <p style={{ color: "red" }}>{errors.address}</p>}
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                            <span>Personal Phone Number<small className='red_starimpo'>*</small></span>
                            <PhoneInput
                                placeholder="Enter phone number"
                                defaultCountry="US"
                                countries={allowedCountries}
                                international={true}
                                limitMaxLength={true}
                                countryCallingCodeEditable={false}
                                value={formData.phone_number}
                                onChange={(value) => handlePhoneChange(value, "phone_number")}
                                onKeyDown={(e) => handleKeyDown(e, "phone_number")}
                                autoComplete="new-password"
                            />
                            {errors.phone_number && <p style={{color:"red"}}>{errors.phone_number}</p>}
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                            <span>Business Phone Number<small className='red_starimpo'>*</small></span>
                            <PhoneInput
                                placeholder="Enter phone number"
                                defaultCountry="US"
                                countries={allowedCountries}
                                international={true}
                                limitMaxLength={true}
                                countryCallingCodeEditable={false}
                                value={formData.business_number}
                                onChange={(value) => handlePhoneChange(value, "business_number")}
                                onKeyDown={(e) => handleKeyDown(e, "business_number")}
                                autoComplete="new-password"
                            />
                            {errors.business_number && <p style={{color:"red"}}>{errors.business_number}</p>}
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container>
                            <Grid size={{xs:12}} container className="mb-4" flexDirection="column">
                                <span>Does this personal phone number support whatsapp ?<small className='red_starimpo'>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                    type="radio"
                                    name="is_whatsapp"
                                    value="1"
                                    checked={formData.is_whatsapp === 1}
                                    onChange={(e) => handleInputChange({
                                        target: { name: "is_whatsapp", value: Number(e.target.value) }
                                    })}
                                    /> Yes
                                    <input
                                    type="radio"
                                    name="is_whatsapp"
                                    value="0"
                                    checked={formData.is_whatsapp === 0}
                                    onChange={(e) => handleInputChange({
                                        target: { name: "is_whatsapp", value: Number(e.target.value) }
                                    })}
                                    /> No
                                </div>
                                {errors.is_whatsapp && <p style={{color:"Red"}}>{errors.is_whatsapp}</p>}
                            </Grid>
                            {formData.is_whatsapp === 0 &&
                            <Grid size={{xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Personal Whatsapp Number<small className='red_starimpo'>*</small></span>
                                <PhoneInput
                                    placeholder="Enter number"
                                    defaultCountry="US"
                                    countries={allowedCountries}
                                    international={true}
                                    limitMaxLength={true}
                                    countryCallingCodeEditable={false}
                                    value={formData.whatsapp_number}
                                    onChange={(value) => handlePhoneChange(value, "whatsapp_number")}
                                    onKeyDown={(e) => handleKeyDown(e, "whatsapp_number")}
                                    autoComplete="new-password"
                                />
                                {errors.whatsapp_number && <p style={{color:"red"}}>{errors.whatsapp_number}</p>}
                            </Grid>}
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container>
                            <Grid size={{xs:12}} container className="mb-4" flexDirection="column">
                                <span>Does this business phone number support business whatsapp ?<small className='red_starimpo'>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                    type="radio"
                                    name="is_business"
                                    value="1"
                                    checked={formData.is_business === 1}
                                    onChange={(e) => handleInputChange({
                                        target: { name: "is_business", value: Number(e.target.value) }
                                    })}
                                    /> Yes
                                    <input
                                    type="radio"
                                    name="is_business"
                                    value="0"
                                    checked={formData.is_business === 0}
                                    onChange={(e) => handleInputChange({
                                        target: { name: "is_business", value: Number(e.target.value) }
                                    })}
                                    /> No
                                </div>
                                {errors.is_business && <p style={{color:"Red"}}>{errors.is_business}</p>}
                            </Grid>
                            {formData.is_business === 0 &&
                            <Grid size={{xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Business Whatsapp Number<small className='red_starimpo'>*</small></span>
                                <PhoneInput
                                    placeholder="Enter number"
                                    defaultCountry="US"
                                    countries={allowedCountries}
                                    international={true}
                                    limitMaxLength={true}
                                    countryCallingCodeEditable={false}
                                    value={formData.business_whatsapp_number}
                                    onChange={(value) => handlePhoneChange(value, "business_whatsapp_number")}
                                    onKeyDown={(e) => handleKeyDown(e, "business_whatsapp_number")}
                                    autoComplete="new-password"
                                />
                                {errors.business_whatsapp_number && <p style={{color:"red"}}>{errors.business_whatsapp_number}</p>}
                            </Grid>}
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                            <span>Industry Start Date<small className='red_starimpo'>*</small></span>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    className="date_pickermux"
                                    value={formData.industry_start_date}
                                    onChange={handleDateChange3}
                                    maxDate={dayjs().subtract(1, 'day')}
                                    renderInput={(params) => <input {...params} />}
                                />
                            </LocalizationProvider>
                            {errors.industry_start_date && <p style={{color:"red"}}>{errors.industry_start_date}</p>}
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                            <span>Start Date<small className='red_starimpo'>*</small></span>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    className="date_pickermux"
                                    minDate={formData.industry_start_date}
                                    maxDate={dayjs()}
                                    value={formData.start_date}
                                    onChange={handleDateChange2}
                                    renderInput={(params) => <input {...params} />}
                                />
                            </LocalizationProvider>
                            {errors.start_date && <p style={{color:"red"}}>{errors.start_date}</p>}
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                            <span>Job Title (Linkedin)<small className='red_starimpo'>*</small></span>
                            <input type="text" name="job_title" value={formData.job_title} onChange={handleInputChange} />
                            {errors.job_title && <p style={{color:"red"}}>{errors.job_title}</p>}
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                            <span>Linkedin URL<small className='red_starimpo'>*</small></span>
                            <input type="text" name="linkedin_url" value={formData.linkedin_url} onChange={handleInputChange} />
                            {errors.linkedin_url && <p style={{color:"red"}}>{errors.linkedin_url}</p>}
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="regiter_inputs mb-4">
                            <span className='mt-0'>Partnership Status<small className='red_starimpo'>*</small></span>
                            <select name="partnership_status" value={formData.partnership_status} onChange={handleInputChange}>
                                <option value="">Select Partnership Status</option>
                                <option value="Senior Partner">Senior Partner</option>
                                <option value="Junior Partner">Junior Partner</option>
                                <option value="Senior Associates">Senior Associates</option>
                                <option value="Junior Associates">Junior Associates</option>
                                <option value="Not a Partner">Not a Partner</option>
                            </select>
                            {errors.partnership_status && <p style={{color:"red"}}>{errors.partnership_status}</p>}
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="regiter_inputs mb-4">
                            <span className='mt-0'>Primary Department<small className='red_starimpo'>*</small></span>
                            <select name="primary_department" value={formData.primary_department} onChange={handleInputChange}>
                                <option value="">Select Primary Department</option>
                                <option value="BSD/FSD">BSD/FSD</option>
                                <option value="ITRD">ITRD</option>
                                <option value="HRAC">HRAC</option>
                                <option value="PRCA">PRCA</option>
                                <option value="PV">PV</option>
                            </select>
                            {errors.primary_department && <p style={{color:"red"}}>{errors.primary_department}</p>}
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="regiter_inputs mb-4">
                            <span className='mt-0'>Industry Sector<small className='red_starimpo'>*</small></span>
                            <select name="industry_sector" value={formData.industry_sector} onChange={handleInputChange}>
                                <option value="">Select Industry Sector</option>
                                <option value="Staffing & Recruitment">Staffing & Recruitment</option>
                                <option value="Information Technology">Information Technology</option>
                                <option value="Human Resources & Accounts">Human Resources & Accounts</option>
                                <option value="Client Acquisition & Public Relations">Client Acquisition & Public Relations</option>
                            </select>
                            {errors.industry_sector && <p style={{color:"red"}}>{errors.industry_sector}</p>}
                        </Grid>
                    </Grid>
                    {errorsmessage && <p style={{ color: 'red' }}>{errorsmessage}</p>}
                    <Grid size={{sm:11,xs:12}} container justifyContent="flex-end" className="gap-3 my-3">
                        <button className='border_btnpink' onClick={()=>navigate("/user/member")}>Cancel</button>
                        <button type="submit" className='bgpink_btnpink addsubs_btn'>{btnloading ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Add Sub Admin'}</button>
                    </Grid>
                </form>
            </Grid>
        </div>
    </div>
  )
}

export default UserMemberAdd
